/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import EVENTS from 'modules/common/constants/events';
/**
 * Define all the event showing calender color schema
 */
const EVENT_COLORS = {
  [EVENTS.ANNUAL_SPORTS_EVENT]: '#B9273C',
  [EVENTS.WEATHER_FORECASTABLE]: '#F9EC2B',
  [EVENTS.WEATHER_NON_FORECASTABLE]: '#B43292',
  [EVENTS.US_HOLIDAY]: '#FCC71F',
  [EVENTS.US_LONG_WEEKEND]: '#8E61A6',
  [EVENTS.FESTIVAL]: '#FFA657',
  [EVENTS.ENTERTAINMENT]: '#323B96',
  [EVENTS.CITY_WIDE_CONFERENCE]: '#F0642F',
  [EVENTS.CONFERENCE_AND_SHOWS]: '#01AFC8',
  [EVENTS.HOTEL_GROUP_BOOKINGS]: '#EB2A2D',
  [EVENTS.OTHER]: '#6AB98C',
  [EVENTS.REGULAR_SPORTS_EVENT]: '#6FBB10',
};
//
export default EVENT_COLORS;
